import React from "react";
import { LightMode } from "@mui/icons-material";

/**
 * Get icon for illuminance widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getIlluminanceIcon = (widget = null) => {
  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };

  return <LightMode {...iconProps} />;
};

export const getIlluminanceSubtitle = (widget = null) => {
  if (!widget) return "";

  const lux = widget?.items?.$w1?.value;

  if (lux !== undefined && lux !== null) {
    return `${lux} lux`;
  }

  return "";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getIlluminancePatterns = () => {
  return ["basic.device.illuminance"];
};
